import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import './subNavigationMenu.scss';

const SubNavigationMenu = ({ items, currentTabName}) => {
  const location = useLocation();

  const isActive = (name) => currentTabName === name;

  return (
    <ul className="sub-navigation-menu">
      {items.map((item) => (item.enabled) ? (
        <li key={item.name}>
        <Link
          to='#'
          className={`nav-item ${isActive(item.name) ? 'active' : ''}`}
          {...(isActive(item.name) ? { 'aria-current': 'page' } : {})}
          {...(item.onClickAction ? {onClick: (e) => {e.preventDefault(); item.onClickAction()}} : {})}
        >
          {item.label}
        </Link>
        </li>
      ) : '')}
    </ul>
  );
};

SubNavigationMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      onClickAction: PropTypes.func
    })
  ).isRequired
};

export default SubNavigationMenu;
